export default __webpack_public_path__ + "static/media/m_no_img.6a5b70e2.png";